import React from "react";
import { TextField } from "components/input/TextField/TextField";

export const TextFieldWithLock = React.memo(
  ({
    optionName,
    optionValue,
    optionLabel,
    optionPlaceholder,
    handleOptionInfoChange,
    widthValue = "100%",
    maxLength,
    minLength,
    required = false,
    disabled = false,
    readOnly = false,
    error,
    type,
  }: {
    // optionName: keyof LibraryDataType;
    optionName: any;
    optionValue: any;
    optionLabel?: string;
    optionPlaceholder?: string;
    handleOptionInfoChange: any;
    widthValue?: string;
    maxLength?: number;
    minLength?: number;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    error?: any;
    type?: any;
    width?: any;
  }) => {
    return (
      <TextField
        type={type}
        size="large"
        label={optionLabel}
        required={required}
        value={optionValue ?? ""}
        handleValue={(value) => handleOptionInfoChange(optionName, value)}
        width={widthValue}
        placeholder={optionPlaceholder}
        disabled={disabled}
        readOnly={readOnly}
        icon={readOnly ? "Lock01" : undefined}
        maxLength={maxLength}
        minLength={minLength}
        lengthCount={maxLength !== undefined}
        error={error}
      />
    );
  }
);
